(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["marbl-accordion-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function (event) {
    var row = event.target;
    if (!row.matches || !row.matches('[data-marbl-accordion]') || !row.open) return;
    var group = row.dataset.group;
    if (!group) return;
    document.querySelectorAll('[data-marbl-accordion][data-group="' + group + '"]').forEach(function (other) {
      if (other !== row) other.open = false;
    });
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marbl-cut-dropdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-marbl-dropdown-trigger]');
    if (!trigger) return;
    var dropdown = trigger.closest('[data-marbl-dropdown]');
    var panel = dropdown.querySelector('[data-marbl-dropdown-panel]');
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';

    document.querySelectorAll('[data-marbl-dropdown-trigger][aria-expanded="true"]').forEach(function (other) {
      if (other !== trigger) {
        other.setAttribute('aria-expanded', 'false');
        other.closest('[data-marbl-dropdown]').querySelector('[data-marbl-dropdown-panel]').hidden = true;
        other.closest('[data-marbl-dropdown]').dataset.open = 'false';
      }
    });

    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
    dropdown.dataset.open = String(!isOpen);
  });

  function marblRecalculateDropdown(dropdown) {
    var capacity = parseInt(dropdown.dataset.capacity, 10) || 0;
    var capacityMode = dropdown.dataset.capacityMode || 'exact';
    var rows = dropdown.querySelectorAll('.marbl-cut-dropdown__row');
    var maxPremium = parseInt(dropdown.dataset.maxPremium, 10) || 0;
    var total = 0;
    var weightGrams = 0;
    var premiumTotal = 0;

    rows.forEach(function (row) {
      var stepper = row.querySelector('[data-marbl-stepper]');
      var value = stepper ? parseInt(stepper.dataset.value, 10) || 0 : 0;
      var unitWeightGrams = parseInt(row.dataset.weightGrams, 10) || 0;
      total += value;
      weightGrams += value * unitWeightGrams;
      if (row.dataset.premium === 'true') premiumTotal += value;
    });

    // Only the few cuts flagged data-premium="true" share a per-box allowance (max_premium).
    // Everything else is untouched by this rule — a box can still be filled entirely with one
    // non-premium cut. max_premium of 0 (or blank) means no allowance is in force at all.
    var premiumAtCap = maxPremium > 0 && premiumTotal >= maxPremium;

    // Hard-stop at the tier's total capacity, not just each cut's own per-item cap. Without
    // this, a shopper could stack several different cuts past the box's real capacity (each
    // individually under its own per-cut max) and only find out at the CTA, then have to
    // delete back down — instead, every "+" glyph in the panel disappears the instant the
    // total hits capacity, and the only way to change the mix from there is minus one cut
    // before a "+" reappears anywhere. Doesn't apply to capacity_mode 'minimum' (Custom),
    // which has no upper bound by design.
    var atCapacity = capacityMode === 'exact' && capacity > 0 && total >= capacity;
    rows.forEach(function (row) {
      var stepper = row.querySelector('[data-marbl-stepper]');
      if (!stepper) return;
      var value = parseInt(stepper.dataset.value, 10) || 0;
      var max = parseInt(stepper.dataset.max, 10) || 0;
      var ownCapReached = max > 0 && value >= max;
      var isPremium = row.dataset.premium === 'true';
      var plus = stepper.querySelector('.marbl-stepper__glyph--plus');
      if (plus) plus.hidden = ownCapReached || atCapacity || (isPremium && premiumAtCap);
    });

    var premiumNote = dropdown.querySelector('[data-marbl-dropdown-premium-note]');
    if (premiumNote) premiumNote.hidden = !premiumAtCap;

    var primaryEl = dropdown.querySelector('[data-marbl-dropdown-count-primary]');
    var weightEl = dropdown.querySelector('[data-marbl-dropdown-count-weight]');
    var cta = dropdown.querySelector('.marbl-cut-dropdown__cta');

    if (primaryEl) {
      primaryEl.textContent = capacityMode === 'minimum'
        ? total + ' units selected · min ' + capacity
        : total + ' of ' + capacity + ' units selected';
    }
    if (weightEl) weightEl.textContent = '· ≈ ' + (weightGrams / 1000).toFixed(1) + ' kg';
    // Orders closed (T13): the CTA opens the waitlist, so it stays enabled at any cut count.
    if (cta && dropdown.dataset.ordersClosed !== 'true') {
      cta.disabled = capacityMode === 'minimum' ? total < capacity : total !== capacity;
    }
  }

  // The chosen frequency's own box price in cents (2026-09-24, T16): once-off = variant price,
  // weekly/fortnightly/monthly = that plan's own allocation price (data-plan-<frequency>-cents).
  function marblFrequencyCents(dropdown) {
    var frequency = dropdown.dataset.frequency || 'once-off';
    var key = frequency === 'once-off'
      ? 'onceOffCents'
      : 'plan' + frequency.charAt(0).toUpperCase() + frequency.slice(1) + 'Cents';
    return parseInt(dropdown.dataset[key], 10) || 0;
  }

  function marblFormatCents(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function marblUpdateDropdownPriceLabel(dropdown) {
    var priceEl = dropdown.querySelector('[data-marbl-dropdown-price]');
    if (!priceEl) return;

    var frequency = dropdown.dataset.frequency || 'once-off';
    var onceOffPrice = dropdown.dataset.onceOffPrice || '';
    var capacityMode = dropdown.dataset.capacityMode || 'exact';
    var capacity = dropdown.dataset.capacity;

    var label;
    if (frequency === 'once-off') {
      label = 'ONCE-OFF · ' + onceOffPrice;
    } else {
      label = frequency.toUpperCase() + ' · ' + marblFormatCents(marblFrequencyCents(dropdown)) + ' PER DELIVERY';
    }
    if (capacityMode === 'minimum') {
      label += ' · MIN ' + capacity + ' UNITS';
    }
    priceEl.textContent = label;
  }

  // Per-cut price beside the units counter (2026-09-10). Recalculates from the box's own
  // once-off/subscribed cents and capacity whenever the frequency changes — capacity is fixed
  // per tier, so this does NOT need to run on stepper-change, only on frequency-change and once
  // on load.
  function marblUpdatePerCutPrice(dropdown) {
    var perCutEl = dropdown.querySelector('[data-marbl-dropdown-count-percut]');
    if (!perCutEl) return;
    var capacity = parseInt(dropdown.dataset.capacity, 10) || 0;
    if (capacity <= 0) {
      perCutEl.textContent = '';
      return;
    }
    var cents = marblFrequencyCents(dropdown);
    if (cents <= 0) { perCutEl.textContent = ''; return; }
    // Per-unit (minimum-mode) tiers: the price already is the per-cut price. Otherwise round to
    // whole cents half-up first - the same rule as Liquid's round on the server-rendered tile - so
    // tile and dropdown always agree (65550 / 20 = 3277.5c is $32.78 in both; toFixed(2) alone gave $32.77).
    var perCutCents = (dropdown.dataset.capacityMode || 'exact') === 'minimum' ? cents : Math.round(cents / capacity);
    perCutEl.textContent = '· $' + (perCutCents / 100).toFixed(2) + ' per cut';
  }

  // Order summary (2026-09-15) - itemized cuts + add-ons + Box/Add-ons/Total roll-up + weight,
  // shown above the footer's CTA in every tier. Box price follows the chosen frequency
  // (once-off vs. subscribed, same cents the footer's per-cut price and price label already
  // use); add-on prices never change with frequency - add-ons are one-off only. Also owns the
  // "this delivery only" note, same as the order-total line it replaces.
  function marblUpdateOrderSummary(dropdown) {
    var summaryEl = dropdown.querySelector('[data-marbl-order-summary]');
    var recurringNote = dropdown.querySelector('[data-marbl-addons-recurring-note]');
    var frequency = dropdown.dataset.frequency || 'once-off';
    if (recurringNote) recurringNote.hidden = frequency === 'once-off';
    if (!summaryEl) return;

    var capacity = parseInt(dropdown.dataset.capacity, 10) || 0;
    var priceCents = marblFrequencyCents(dropdown);
    var perUnitMode = (dropdown.dataset.capacityMode || 'exact') === 'minimum';
    var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

    var total = 0;
    var weightGrams = 0;
    var cutLines = [];
    dropdown.querySelectorAll('.marbl-cut-dropdown__row').forEach(function (row) {
      var stepper = row.querySelector('[data-marbl-stepper]');
      var qty = stepper ? parseInt(stepper.dataset.value, 10) || 0 : 0;
      var unitWeightGrams = parseInt(row.dataset.weightGrams, 10) || 0;
      total += qty;
      weightGrams += qty * unitWeightGrams;
      if (qty > 0) cutLines.push(qty + ' × ' + row.dataset.cutName);
    });

    var addonCents = 0;
    var addonLines = [];
    dropdown.querySelectorAll('.marbl-cut-dropdown__addon-row').forEach(function (row) {
      var stepper = row.querySelector('[data-marbl-stepper]');
      var qty = stepper ? parseInt(stepper.dataset.value, 10) || 0 : 0;
      if (qty <= 0) return;
      var lineCents = qty * (parseInt(row.dataset.addonPriceCents, 10) || 0);
      addonCents += lineCents;
      addonLines.push({ text: qty + ' × ' + row.dataset.addonName, cents: lineCents });
    });

    // Per-unit tiers charge quantity x unit price at checkout (see the CTA handler in
    // marbl-boxes.liquid: quantity = units chosen), so the summary must do the same.
    // hasPrice is false on pages that render the dropdown without a price (change-your-cuts): show
    // the cuts and weight only, never "$0.00".
    var hasPrice = priceCents > 0;
    var boxCents = perUnitMode ? priceCents * total : priceCents;
    var perCutCents = perUnitMode ? priceCents : (capacity > 0 ? Math.round(priceCents / capacity) : 0);

    var html = '<p class="marbl-data marbl-cut-dropdown__summary-header">'
      + (perUnitMode ? total + ' cuts (minimum ' + capacity + ')' : total + ' of ' + capacity + ' cuts')
      + (hasPrice ? ' · ' + money(perCutCents) + ' per cut' : '') + '</p>';

    if (cutLines.length) {
      html += '<div class="marbl-cut-dropdown__summary-lines">' + cutLines.map(function (line) {
        return '<p class="marbl-cut-dropdown__summary-line"><span>' + line + '</span></p>';
      }).join('') + '</div>';
    }

    if (addonLines.length) {
      html += '<div class="marbl-cut-dropdown__summary-addons">'
        + '<p class="marbl-secondary marbl-cut-dropdown__summary-addons-label">Add-ons</p>'
        + addonLines.map(function (line) {
          return '<p class="marbl-cut-dropdown__summary-line"><span>' + line.text + '</span><span>' + money(line.cents) + '</span></p>';
        }).join('') + '</div>';
    }

    var totalCents = boxCents + addonCents;
    if (hasPrice) {
    html += '<div class="marbl-cut-dropdown__summary-totals">'
      + '<p class="marbl-cut-dropdown__summary-line"><span>Box</span><span>' + money(boxCents) + '</span></p>';
    if (addonLines.length) {
      html += '<p class="marbl-cut-dropdown__summary-line"><span>Add-ons</span><span>' + money(addonCents) + '</span></p>';
    }
    html += '<p class="marbl-cut-dropdown__summary-line marbl-cut-dropdown__summary-line--total"><span>Total</span><span>' + money(totalCents) + '</span></p>'
      + '</div>';
    }

    html += '<p class="marbl-secondary marbl-cut-dropdown__summary-weight">Estimated weight ≈ ' + (weightGrams / 1000).toFixed(1) + ' kg</p>';

    summaryEl.innerHTML = html;
  }

  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-marbl-dropdown-frequency] .marbl-segmented__option');
    if (!option) return;

    var group = option.closest('[data-marbl-dropdown-frequency]');
    group.querySelectorAll('.marbl-segmented__option').forEach(function (btn) {
      btn.classList.remove('is-selected');
    });
    option.classList.add('is-selected');

    group.querySelectorAll('.marbl-segmented__option').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(btn === option));
    });

    var dropdown = option.closest('[data-marbl-dropdown]');
    if (!dropdown) return;
    dropdown.dataset.frequency = option.dataset.frequency;
    marblUpdateDropdownPriceLabel(dropdown);
    marblUpdatePerCutPrice(dropdown);
    marblUpdateOrderSummary(dropdown);
  });

  // 2026-11-01 (v16): boxes with data-max-addons > 0 (Essentials) cap the total add-on packs.
  // Add-on steppers are uncapped individually (max 0), so hide every add-on "+" at the cap.
  function marblApplyAddonCap(dropdown) {
    var maxAddons = parseInt(dropdown.dataset.maxAddons, 10) || 0;
    if (maxAddons <= 0) return;
    var rows = dropdown.querySelectorAll('.marbl-cut-dropdown__addon-row');
    var total = 0;
    rows.forEach(function (row) {
      var s = row.querySelector('[data-marbl-stepper]');
      total += s ? parseInt(s.dataset.value, 10) || 0 : 0;
    });
    rows.forEach(function (row) {
      var plus = row.querySelector('.marbl-stepper__glyph--plus');
      if (plus) plus.hidden = total >= maxAddons;
    });
  }

  document.addEventListener('marbl:stepper-change', function (event) {
    var dropdown = event.target.closest('[data-marbl-dropdown]');
    if (!dropdown) return;
    marblApplyAddonCap(dropdown);
    marblRecalculateDropdown(dropdown);
    marblUpdateOrderSummary(dropdown);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-marbl-dropdown]').forEach(function (dropdown) {
      marblRecalculateDropdown(dropdown);
      marblUpdatePerCutPrice(dropdown);
      marblUpdateOrderSummary(dropdown);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marbl-stepper"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var glyph = event.target.closest('.marbl-stepper__glyph');
    if (!glyph) return;
    var stepper = glyph.closest('[data-marbl-stepper]');
    if (!stepper) return;

    var max = parseInt(stepper.dataset.max, 10) || 0;
    var value = parseInt(stepper.dataset.value, 10) || 0;
    var isPlus = glyph.classList.contains('marbl-stepper__glyph--plus');
    var atCap = max > 0 && value >= max;

    if (isPlus && !atCap) value += 1;
    if (!isPlus && value > 0) value -= 1;

    atCap = max > 0 && value >= max;

    stepper.dataset.value = value;
    stepper.querySelector('.marbl-stepper__count').textContent = value;
    stepper.querySelector('.marbl-stepper__glyph--minus').hidden = value === 0;
    stepper.querySelector('.marbl-stepper__glyph--plus').hidden = atCap;
    stepper.querySelector('.marbl-stepper__max').hidden = !atCap;

    stepper.dispatchEvent(new CustomEvent('marbl:stepper-change', {
      bubbles: true,
      detail: { name: stepper.dataset.name, value: value }
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marbl-waitlist"] && !Shopify.designMode) return;
  try {
    (function () {
    var WAITLIST_FORM_ID = 'marbl-waitlist-form';
    var STORAGE_KEY = 'marbl-customer-form-submitted';

    // Tags = the base tags + postcode-XXXX + interest-<box handle>. Kept current on every input
    // (not only at submit) so the value is right however the form ends up being submitted.
    function syncWaitlistTags(form) {
      var tagsInput = form.querySelector('[data-marbl-waitlist-tags]');
      if (!tagsInput) return;
      var tags = (tagsInput.getAttribute('data-marbl-base-tags') || 'waitlist').split(',').filter(Boolean);
      var postcodeInput = form.querySelector('[data-marbl-waitlist-postcode]');
      var postcode = postcodeInput ? postcodeInput.value.trim() : '';
      if (/^\d{4}$/.test(postcode)) tags.push('postcode-' + postcode);
      if (form.dataset.interest) tags.push('interest-' + form.dataset.interest);
      tagsInput.value = tags.join(',');
    }

    var returnFocusTo = null;

    function showWaitlistDialog(dialog) {
      if (dialog.open) return;
      returnFocusTo = document.activeElement;
      if (typeof dialog.show === 'function') dialog.show();
      else dialog.setAttribute('open', '');
      var backdrop = document.querySelector('[data-marbl-waitlist-backdrop]');
      if (backdrop) backdrop.hidden = false;
      var first = dialog.querySelector('#marbl-waitlist-first-name');
      if (first && first.offsetParent !== null) first.focus();
      else dialog.querySelector('[data-marbl-waitlist-close]').focus();
    }

    function closeWaitlistDialog() {
      var dialog = document.getElementById('marbl-waitlist');
      if (!dialog || !dialog.open) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      var backdrop = document.querySelector('[data-marbl-waitlist-backdrop]');
      if (backdrop) backdrop.hidden = true;
      if (returnFocusTo && document.contains(returnFocusTo) && typeof returnFocusTo.focus === 'function') returnFocusTo.focus();
      returnFocusTo = null;
    }

    window.marblOpenWaitlist = function (options) {
      options = options || {};
      var dialog = document.getElementById('marbl-waitlist');
      var form = document.getElementById(WAITLIST_FORM_ID);
      if (!dialog || !form) {
        console.warn('Marbl: waitlist form not on this page');
        return;
      }

      form.dataset.interest = options.interest ? String(options.interest).toLowerCase().replace(/[^a-z0-9-]/g, '') : '';
      var postcodeInput = form.querySelector('[data-marbl-waitlist-postcode]');
      if (postcodeInput && options.postcode) postcodeInput.value = options.postcode;
      syncWaitlistTags(form);

      var context = dialog.querySelector('[data-marbl-waitlist-context]');
      if (context) {
        if (options.outOfZone && /^\d{4}$/.test(options.postcode || '')) {
          context.textContent = "We don't deliver to " + options.postcode + " yet. Join the waitlist and we'll let you know as we widen, suburb by suburb.";
          context.hidden = false;
        } else {
          context.textContent = '';
          context.hidden = true;
        }
      }

      showWaitlistDialog(dialog);
    };

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-marbl-waitlist-open]');
      if (opener) {
        event.preventDefault();
        window.marblOpenWaitlist({
          postcode: opener.dataset.postcode || '',
          outOfZone: opener.dataset.outOfZone === 'true',
          interest: opener.dataset.interest || '',
        });
        return;
      }
      if (event.target.closest('[data-marbl-waitlist-close]')) closeWaitlistDialog();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeWaitlistDialog();
    });

    // Soft Tab loop (2026-09-25, fix round 1): Tab from the last control goes back to the first
    // (Shift+Tab the reverse) instead of into the page hidden under the backdrop. It stands down
    // while an hCaptcha challenge is on screen - the challenge lives outside the dialog.
    function hcaptchaChallengeVisible() {
      return Array.prototype.some.call(document.querySelectorAll('iframe[src*="hcaptcha"]'), function (frame) {
        var rect = frame.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && window.getComputedStyle(frame).visibility !== 'hidden';
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var dialog = document.getElementById('marbl-waitlist');
      if (!dialog || !dialog.open || !dialog.contains(document.activeElement)) return;
      if (hcaptchaChallengeVisible()) return;
      var focusable = Array.prototype.filter.call(
        dialog.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('input', function (event) {
      if (!event.target.matches('[data-marbl-waitlist-postcode]')) return;
      var form = event.target.form;
      if (form) syncWaitlistTags(form);
    });

    // Postcode + box interest, kept for the submitted tab only so an error page can put them back
    // (2026-09-25, fix round 1). The email is never stored here.
    var DRAFT_KEY = 'marbl-waitlist-draft';

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.classList || !form.classList.contains('marbl-customer-form')) return;
      if (form.id === WAITLIST_FORM_ID) {
        syncWaitlistTags(form);
        var postcodeInput = form.querySelector('[data-marbl-waitlist-postcode]');
        try {
          window.sessionStorage.setItem(DRAFT_KEY, JSON.stringify({
            postcode: postcodeInput ? postcodeInput.value.trim() : '',
            interest: form.dataset.interest || '',
          }));
        } catch (error) { /* storage blocked */ }
      }
      try { window.sessionStorage.setItem(STORAGE_KEY, form.id); } catch (error) { /* storage blocked */ }
    });

    function restoreWaitlistDraft(form) {
      var draft = null;
      try { draft = JSON.parse(window.sessionStorage.getItem(DRAFT_KEY) || 'null'); } catch (error) { draft = null; }
      if (!draft) return;
      var postcodeInput = form.querySelector('[data-marbl-waitlist-postcode]');
      if (postcodeInput && !postcodeInput.value && /^\d{4}$/.test(draft.postcode || '')) postcodeInput.value = draft.postcode;
      if (draft.interest) form.dataset.interest = String(draft.interest).toLowerCase().replace(/[^a-z0-9-]/g, '');
      syncWaitlistTags(form);
    }

    // After Shopify's redirect back, show the state only on the form that was submitted.
    // The markers are read and cleared only on a page that actually carries a posted state, so an
    // in-between page (e.g. Shopify's /challenge) can't consume them first.
    function revealPostedState() {
      if (!document.querySelector('[data-marbl-form-state]')) return;
      var submitted = '';
      var hash = (window.location.hash || '').slice(1);
      var hashTarget = hash ? document.getElementById(hash) : null;
      if (hashTarget && hashTarget.classList.contains('marbl-customer-form')) submitted = hash;
      if (!submitted) {
        try { submitted = window.sessionStorage.getItem(STORAGE_KEY) || ''; } catch (error) { /* storage blocked */ }
      }
      try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (error) { /* storage blocked */ }
      var form = submitted ? document.getElementById(submitted) : null;
      var state = form ? form.querySelector('[data-marbl-form-state]') : null;
      if (!state) {
        try { window.sessionStorage.removeItem(DRAFT_KEY); } catch (error) { /* storage blocked */ }
        console.warn('Marbl: a customer form was posted but the submitted form could not be identified');
        return;
      }
      state.hidden = false;
      state.setAttribute('tabindex', '-1');
      if (state.dataset.marblFormState === 'success') {
        form.querySelectorAll('[data-marbl-form-fields]').forEach(function (fields) { fields.hidden = true; });
      } else if (form.id === WAITLIST_FORM_ID) {
        restoreWaitlistDraft(form);
      }
      try { window.sessionStorage.removeItem(DRAFT_KEY); } catch (error) { /* storage blocked */ }
      if (form.id === WAITLIST_FORM_ID) {
        var dialog = document.getElementById('marbl-waitlist');
        if (dialog) showWaitlistDialog(dialog);
      }
      // Focus again once the page has loaded, but only if focus was lost (nothing else took it):
      // the browser's jump to the #fragment blurs whatever was focused (seen on the preview).
      state.focus();
      var refocusState = function () {
        var active = document.activeElement;
        if ((!active || active === document.body) && !state.hidden) state.focus();
      };
      if (document.readyState === 'complete') window.setTimeout(refocusState, 0);
      else window.addEventListener('load', function () { window.setTimeout(refocusState, 0); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealPostedState);
    else revealPostedState();
  })();
  } catch(e) { console.error(e); }
})();

})();
